//returns an array of paths to partials
function selectPartialsFromHTML(elementHTML){
    //TODO? this regex may or may not be improved
    const inclusionRegex = /{%-?\s*include\s*(['"`])(partials.+?\.html)\1.*?\s*-?%}/g
    const matches = [];
    let match = undefined;
    while((match = inclusionRegex.exec(elementHTML))!==null) {
        matches.push(match[2]);
    }
    return matches;
}

export default selectPartialsFromHTML;